const items = [
  {
    id: 'card-1',
    title: '独家深扒：顶流主播直播间背后的灰色产业链',
    desc: '深度调查揭露直播行业刷量、刷评、控评的完整操作流程，涉及多家头部MCN机构。',
    tag: '独家调查',
    time: '3小时前',
    img: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20scene%20with%20documents%20and%20screens%20in%20warm%20dramatic%20lighting%2C%20dark%20moody%20background%20with%20soft%20amber%20highlights%2C%20professional%20editorial%20photography%2C%20warm%20crimson%20accents%2C%20cinematic%20composition%2C%20mysterious%20atmosphere&width=800&height=560&seq=cards-1&orientation=landscape',
  },
  {
    id: 'card-2',
    title: '网红情侣分手全记录：从甜蜜营业到彻底撕破脸',
    desc: '整理两人从公开恋情、商业绑定到最终分道扬镳的完整时间线，聊天记录首次曝光。',
    tag: '情感八卦',
    time: '6小时前',
    img: 'https://readdy.ai/api/search-image?query=Emotional%20breakup%20concept%20with%20two%20separated%20silhouettes%20in%20warm%20golden%20and%20deep%20red%20lighting%2C%20dramatic%20atmosphere%2C%20cinematic%20photography%20style%2C%20soft%20focus%2C%20elegant%20dark%20background%2C%20editorial%20mood%2C%20emotional%20tension&width=800&height=560&seq=cards-2&orientation=landscape',
  },
  {
    id: 'card-3',
    title: '千万粉吃播博主被曝假吃剪辑，背后团队连夜删视频',
    desc: '技术流网友逐帧分析揭露造假细节，平台已对该账号做出限流处理。',
    tag: '造假曝光',
    time: '9小时前',
    img: 'https://readdy.ai/api/search-image?query=Food%20content%20creation%20studio%20with%20dramatic%20warm%20lighting%2C%20plates%20and%20camera%20equipment%2C%20atmosphere%20of%20deception%20revealed%2C%20dark%20moody%20background%20with%20amber%20accents%2C%20editorial%20photography%2C%20cinematic%20composition%2C%20intense%20warm%20tones&width=800&height=560&seq=cards-3&orientation=landscape',
  },
  {
    id: 'card-4',
    title: '平台大清洗：一批违规网红账号被永久封禁',
    desc: '官方发布最新整治公告，涉及炫富、低俗、虚假人设等多类违规内容。',
    tag: '平台动态',
    time: '12小时前',
    img: 'https://readdy.ai/api/search-image?query=Digital%20account%20suspension%20concept%20with%20glowing%20warning%20signs%20in%20warm%20crimson%20and%20amber%20light%2C%20abstract%20network%20visualization%2C%20dramatic%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20elegant%20background%2C%20cinematic%20mood%2C%20intense%20warm%20tones&width=800&height=560&seq=cards-4&orientation=landscape',
  },
  {
    id: 'card-5',
    title: '揭秘：MCN机构如何批量制造网红人设',
    desc: '前MCN员工匿名投稿，详细讲述从人设策划到内容运营的完整工业流程。',
    tag: '行业揭秘',
    time: '1天前',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20creative%20studio%20with%20storyboards%20and%20screens%2C%20warm%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20dark%20background%20with%20amber%20highlights%2C%20cinematic%20composition%2C%20professional%20setting%2C%20warm%20golden%20tones&width=800&height=560&seq=cards-5&orientation=landscape',
  },
  {
    id: 'card-6',
    title: '网红跨界开店频频翻车，粉丝经济还能走多远？',
    desc: '盘点近三年网红实体商业失败案例，分析粉丝变现模式的天花板与风险。',
    tag: '商业分析',
    time: '2天前',
    img: 'https://readdy.ai/api/search-image?query=Failed%20storefront%20concept%20with%20closed%20sign%20in%20warm%20dramatic%20lighting%2C%20empty%20retail%20space%2C%20atmosphere%20of%20business%20failure%2C%20editorial%20photography%20style%2C%20dark%20background%20with%20soft%20amber%20accents%2C%20cinematic%20composition%2C%20warm%20melancholic%20tones&width=800&height=560&seq=cards-6&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">爆料精选</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">编辑推荐</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item) => (
            <a
              key={item.id}
              href={`#carousel`}
              className="group flex flex-col bg-background-50 rounded-lg border border-secondary-200/60 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden bg-secondary-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.classList.add('hidden');
                  }}
                />
                <div className="absolute top-2 left-2">
                  <span className="text-xs font-medium text-background-50 bg-primary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="flex-1 flex flex-col p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2 leading-snug">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}